import {
  Text,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components';
import {
  Desktop16Regular,
  WeatherMoon16Regular,
  WeatherSunny16Regular,
} from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import SegmentedSwitch from '../SegmentedSwitch';
import { useColorScheme } from './ColorSchemeContext';

const useStyles = makeStyles({
  row: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: tokens.spacingVerticalXS,
  },
  rowFull: {
    alignItems: 'stretch',
    width: '100%',
    minWidth: 0,
  },
  error: {
    color: tokens.colorPaletteRedForeground1,
    marginTop: tokens.spacingVerticalXXS,
  },
});

const ColorSchemeSwitch = ({ fullWidth = false }: { fullWidth?: boolean }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const { colorScheme, saving, error, setColorScheme } = useColorScheme();

  return (
    <div>
      <div className={mergeClasses(styles.row, fullWidth && styles.rowFull)}>
        <Text
          style={{ marginBottom: tokens.spacingVerticalXXS }}
          weight="semibold"
        >
          {t('appearance', 'Appearance')}
        </Text>
        <SegmentedSwitch
          aria-label={t('appearance', 'Appearance')}
          value={colorScheme}
          disabled={saving}
          fullWidth={fullWidth}
          onChange={setColorScheme}
          options={[
            {
              value: 'light',
              label: t('light', 'Light'),
              icon: <WeatherSunny16Regular />,
            },
            {
              value: 'dark',
              label: t('dark', 'Dark'),
              icon: <WeatherMoon16Regular />,
            },
            {
              value: 'system',
              label: t('system', 'System'),
              icon: <Desktop16Regular />,
            },
          ]}
        />
      </div>
      {error ? (
        <Text size={200} className={styles.error}>
          {error}
        </Text>
      ) : null}
    </div>
  );
};

export default ColorSchemeSwitch;
